import { v4 as uuidv4 } from "uuid";

import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "FormParagraphBlock",
  props: {
    value: {
      prop: "other",
      type: "string",
      value: "Form paragraph text",
    },
  },
};
